// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { LitigationAPI } from '../api/models/LitigationAPI';
import { LitigationStatus } from '../types';

export class LitigationEntity {
  static create(data: LitigationAPI): LitigationEntity {
    try {
      return new LitigationEntity(data);
    } catch (error: any) {
      throw new Error(`Failed to create LitigationEntity: ${error.message}`);
    }
  }

  id: string;
  shipmentId: string;
  reason: string;
  details: string;
  status: LitigationStatus;
  createdBy: string;
  createdAt: string;
  updatedAt: string;

  constructor(data: LitigationAPI) {
    this.id = data.id;
    this.shipmentId = data.shipment_id;
    this.reason = data.reason;
    this.details = data.details;
    this.status = data.status;
    this.createdBy = data.created_by;
    this.createdAt = data.created_at;
    this.updatedAt = data.updated_at;
  }
}
